/** Session snapshot of the last in-app page (for Home quick-link tiles). */

export const QUICK_LINK_CAPTURE_STORAGE_KEY = "tw.quick_link_capture";

export interface QuickLinkCapture {
  pathname: string;
  /** Query string without leading `?`. */
  search: string;
  capturedAt: number;
}

const SKIP_PREFIXES = ["/dashboard", "/preferences"];

function shouldCapture(pathname: string): boolean {
  if (!pathname || pathname === "/") return false;
  return !SKIP_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}

export function recordQuickLinkCapture(pathname: string, search: string): void {
  if (!shouldCapture(pathname)) return;
  const payload: QuickLinkCapture = {
    pathname,
    search: search.startsWith("?") ? search.slice(1) : search,
    capturedAt: Date.now(),
  };
  try {
    sessionStorage.setItem(
      QUICK_LINK_CAPTURE_STORAGE_KEY,
      JSON.stringify(payload),
    );
  } catch {
    // Private mode / quota — ignore.
  }
}

export function readQuickLinkCapture(): QuickLinkCapture | null {
  try {
    const raw = sessionStorage.getItem(QUICK_LINK_CAPTURE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as QuickLinkCapture;
    if (typeof parsed.pathname !== "string" || !parsed.pathname) return null;
    return {
      pathname: parsed.pathname,
      search: typeof parsed.search === "string" ? parsed.search : "",
      capturedAt:
        typeof parsed.capturedAt === "number" ? parsed.capturedAt : 0,
    };
  } catch {
    return null;
  }
}

/** Nav base path the capture belongs to (e.g. `/bookings` for `/bookings/abc`). */
export function captureNavBasePath(pathname: string): string {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return "/";
  return `/${segments[0]}`;
}
